var map = {
	"./char-A.svg": 6142,
	"./char-B.svg": 8742,
	"./char-C.svg": 1470,
	"./char-E.svg": 8431,
	"./favicon-180x180.png": 6844,
	"./favicon-192x192.png": 2473,
	"./favicon-270x270.png": 2926,
	"./favicon-32x32.png": 1198,
	"./marker.svg": 4483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7248;